import { styled } from '@volkswagen-onehub/components-core';
import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { fetchProvince } from 'src/bff';
import { useOneFormContext } from 'src/feature-app/OneForm';
import { useIsComerciales } from 'src/feature-app/hooks';
import { TOKEN_LEADS_COMERCIALES, TOKEN_LEADS_TURISMOS } from 'src/globals';
import { OneFormState } from 'src/types';
import { SelectExtended, GeneralInputWidthWrapper } from '.';
import { SelectExtendedList } from './CarlineSelect';
import { InputError, TextInputExtended } from './inputs';
export interface ProvinciaProps {
  notALayer?: boolean;
  noPaddingTop?: boolean;
}

export function Provincia(props: ProvinciaProps) {
  const { notALayer, noPaddingTop } = props;
  const { register, errors } = useFormContext();
  const [errorProvincia, setErrorProvincia] = useState(false);
  const { formData, dealersInfo, formInfo } = useSelector((state: OneFormState) => state);
  const { fields } = formData;

  const { error } = useOneFormContext();
  const [list, setList] = useState<SelectExtendedList[]>(null);
  const dispatch = useDispatch();
  const [provincia, setProvincia] = useState(null);
  const isComerciales = useIsComerciales();

  const formatProvinciaExtendedList = (name: string, code: string): SelectExtendedList => {
    return {
      code,
      name,
      key: name,
    };
  };

  const updateProvinceValues = (provinceCode: string, provinceName: string) => {
    dispatch({ type: 'UPDATE_FIELDS', payload: { provinceCode, provinceName } });
  };

  const handleUpdateList = (list: SelectExtendedList[]) => {
    setList(list);

    if (fields.provinceName) {
      setProvincia(fields.provinceName);
    } else {
      setProvincia(list[0].name);
      updateProvinceValues(list[0].code, list[0].name);
    }
  };

  useEffect(() => {
    const requestProvincias = async () => {
      const provincias = await fetchProvince(isComerciales ? TOKEN_LEADS_COMERCIALES : TOKEN_LEADS_TURISMOS);
      const provinciasFormatted = provincias.content.map((att) => {
        const name = att.attributes[0].value;
        const code = att.attributes[1].value;
        return formatProvinciaExtendedList(name, code);
      });
      handleUpdateList(provinciasFormatted);
    };

    requestProvincias();
  }, []);

  useEffect(() => {
    if (error) {
      !provincia ? setErrorProvincia(true) : setErrorProvincia(false);
    }
  }, [error]);

  useEffect(() => {
    if (errors.provincia) {
      setErrorProvincia(true);
    } else {
      setErrorProvincia(false);
    }
  }, [errors]);

  function handleChangeProvincia(event: any) {
    const newProvinciaValue = event.currentTarget.value;

    setProvincia(newProvinciaValue);
    const newProvincia = list.find((province) => province.name === newProvinciaValue);
    if (newProvincia) {
      updateProvinceValues(newProvincia.code, newProvincia.name);
    }
    if (newProvinciaValue !== '') {
      setErrorProvincia(false);
    }
  }

  return (
    <GeneralInputWidthWrapper notALayer={notALayer} noPaddingTop={noPaddingTop}>
      {list ? (
        <>
          <SelectExtended
            name="provincia"
            label="Selecciona tu provincia"
            value={provincia}
            required
            options={list}
            handleChange={handleChangeProvincia}
            onClick={() => { }}
            updateFields
            setOption={setProvincia}
            isRequired={true}
          />
        </>
      ) : (
        <TextInputExtended
          innerRef={register({
            required: {
              value: true,
              message: 'Requerido',
            },
          })}
          name="provincia"
          label="Modelo"
          isFloating
        />
      )}
      {errorProvincia ? <InputError className="input-error">Este campo es obligatorio</InputError> : null}
      {<input name="provincia" hidden value={provincia} />}
    </GeneralInputWidthWrapper>
  );
}
